(() => {
  if (window.__nexoraProductCardSwatchesLoaded) return;
  window.__nexoraProductCardSwatchesLoaded = true;

  class ProductCardSwatches {
    constructor() {
      this.initializeSwatchCounters();
      this.handleResize = this.initializeSwatchCounters.bind(this);
      window.addEventListener('resize', this.handleResize);
    }

    initializeSwatchCounters() {
      const swatchContainers = document.querySelectorAll('.product-form-swatch__variants');

      swatchContainers.forEach((container) => {
        const swatches = container.querySelectorAll('.swatch');
        const counter = container.querySelector('.swatch-counter');
        const counterNumber = counter?.querySelector('.counter-number');
        if (!swatches.length || !counter || !counterNumber) return;

        const containerWidth = container.offsetWidth;
        const swatchWidth = swatches[0].offsetWidth;
        const gap = 5;
        const swatchesPerRow = Math.floor((containerWidth + gap) / (swatchWidth + gap));

        if (swatches.length > swatchesPerRow) {
          const visibleSwatches = Math.max(0, swatchesPerRow - 1);
          const hiddenCount = swatches.length - visibleSwatches;
          counter.style.display = 'flex';
          counterNumber.textContent = hiddenCount;

          swatches.forEach((swatch, index) => {
            swatch.style.display = index >= visibleSwatches ? 'none' : 'block';
          });
        } else {
          counter.style.display = 'none';
          swatches.forEach((swatch) => {
            swatch.style.display = 'block';
          });
        }
      });
    }
  }

  let productCardSwatches;
  const initializeProductCardSwatches = () => {
    if (productCardSwatches) {
      productCardSwatches.initializeSwatchCounters();
      return;
    }
    productCardSwatches = new ProductCardSwatches();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeProductCardSwatches, { once: true });
  } else {
    initializeProductCardSwatches();
  }

  document.addEventListener('shopify:section:load', initializeProductCardSwatches);
})();
